import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

class PDFGenerator {
  static async generateReport(incidents, filters) {
    const doc = new jsPDF();
    
    // Add logo (you can replace this with actual logo URL)
    try {
      // For now, we'll add a text logo. You can replace this with an actual image
      doc.setFontSize(20);
      doc.setTextColor(220, 38, 127); // Red color
      doc.text('ITURRI', 20, 25);
    } catch (error) {
      console.log('Logo not loaded, continuing without it');
    }

    // Title
    doc.setFontSize(16);
    doc.setTextColor(0, 0, 0);
    doc.text('Informe de Incidencias', 20, 45);

    // Report info
    doc.setFontSize(10);
    doc.setTextColor(100, 100, 100);
    const reportDate = format(new Date(), 'dd/MM/yyyy HH:mm', { locale: es });
    doc.text(`Generado el: ${reportDate}`, 20, 55);
    doc.text(`Total de incidencias: ${incidents.length}`, 20, 62);

    // Filters info
    let yPosition = 75;
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(12);
    doc.text('Filtros aplicados:', 20, yPosition);
    
    yPosition += 8;
    doc.setFontSize(9);
    doc.setTextColor(100, 100, 100);
    
    if (filters.dateFrom) {
      doc.text(`• Fecha desde: ${format(new Date(filters.dateFrom), 'dd/MM/yyyy', { locale: es })}`, 25, yPosition);
      yPosition += 6;
    }
    
    if (filters.dateTo) {
      doc.text(`• Fecha hasta: ${format(new Date(filters.dateTo), 'dd/MM/yyyy', { locale: es })}`, 25, yPosition);
      yPosition += 6;
    }
    
    if (filters.status) {
      const statusLabels = {
        pendiente: 'Pendiente',
        en_proceso: 'En Proceso',
        resuelto: 'Resuelto'
      };
      doc.text(`• Estado: ${statusLabels[filters.status] || filters.status}`, 25, yPosition);
      yPosition += 6;
    }
    
    if (filters.priority) {
      const priorityLabels = {
        baja: 'Baja',
        media: 'Media',
        alta: 'Alta',
        critica: 'Crítica'
      };
      doc.text(`• Prioridad: ${priorityLabels[filters.priority] || filters.priority}`, 25, yPosition);
      yPosition += 6;
    }

    // Table data
    const tableData = incidents.map(incident => [
      format(new Date(incident.createdAt), 'dd/MM/yyyy', { locale: es }),
      incident.title,
      this.getStatusLabel(incident.status),
      this.getPriorityLabel(incident.priority),
      incident.responsible || 'N/A',
      incident.location || 'N/A'
    ]);

    // Add table
    doc.autoTable({
      startY: yPosition + 10,
      head: [['Fecha', 'Título', 'Estado', 'Prioridad', 'Responsable', 'Ubicación']],
      body: tableData,
      styles: {
        fontSize: 8,
        cellPadding: 3
      },
      headStyles: {
        fillColor: [220, 38, 127], // Red color matching the brand
        textColor: 255,
        fontStyle: 'bold'
      },
      alternateRowStyles: {
        fillColor: [248, 249, 250]
      },
      columnStyles: {
        0: { cellWidth: 25 },
        1: { cellWidth: 50 },
        2: { cellWidth: 25 },
        3: { cellWidth: 25 },
        4: { cellWidth: 30 },
        5: { cellWidth: 30 }
      }
    });

    // Summary statistics
    const finalY = doc.lastAutoTable.finalY + 15;
    
    if (finalY < 250) { // Only add summary if there's space
      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0);
      doc.text('Resumen:', 20, finalY);
      
      const stats = this.calculateStats(incidents);
      
      doc.setFontSize(9);
      doc.setTextColor(100, 100, 100);
      let summaryY = finalY + 8;
      
      doc.text(`• Total de incidencias: ${stats.total}`, 25, summaryY);
      summaryY += 6;
      doc.text(`• Pendientes: ${stats.pendiente}`, 25, summaryY);
      summaryY += 6;
      doc.text(`• En proceso: ${stats.en_proceso}`, 25, summaryY);
      summaryY += 6;
      doc.text(`• Resueltas: ${stats.resuelto}`, 25, summaryY);
      summaryY += 6;
      doc.text(`• Prioridad alta/crítica: ${stats.highPriority}`, 25, summaryY);
    }

    // Save the PDF
    const fileName = `informe_incidencias_${format(new Date(), 'yyyyMMdd_HHmm')}.pdf`;
    doc.save(fileName);
  }

  static getStatusLabel(status) {
    const labels = {
      pendiente: 'Pendiente',
      en_proceso: 'En Proceso',
      resuelto: 'Resuelto'
    };
    return labels[status] || status;
  }

  static getPriorityLabel(priority) {
    const labels = {
      baja: 'Baja',
      media: 'Media',
      alta: 'Alta',
      critica: 'Crítica'
    };
    return labels[priority] || priority;
  }

  static calculateStats(incidents) {
    return {
      total: incidents.length,
      pendiente: incidents.filter(i => i.status === 'pendiente').length,
      en_proceso: incidents.filter(i => i.status === 'en_proceso').length,
      resuelto: incidents.filter(i => i.status === 'resuelto').length,
      highPriority: incidents.filter(i => i.priority === 'alta' || i.priority === 'critica').length
    };
  }
}

export default PDFGenerator;